export const cocoonPrivateRoutes = [
	{ mode: 'redirect', path: /\/booking\/.*/ },
	{ mode: 'redirect', path: /\/favorites$/ },
	{ mode: 'redirect', path: /\/events$/ },
	{ mode: 'redirect', path: /\/account$/ },
	{ mode: 'redirect', path: /\/account\/.*/ },
	{ mode: 'redirect', path: /\/dashboard$/ },
	{ mode: 'dialog', path: /\/payment\/.*/ },
	{ mode: 'dialog', path: /\/overstays\/.*/ },
	{ mode: 'dialog', path: /\/scheduling$/ },
	{ mode: 'dialog', path: /\/scheduling\/onboarding(\/.*)?$/ },
	{ mode: 'dialog', path: /\/scheduling\/availabilities/ },
	{ mode: 'dialog', path: /\/scheduling\/event-types/ },
	{ mode: 'dialog', path: /\/scheduling\/locations/ },
	{ mode: 'dialog', path: /\/scheduling\/bookings/ },
]
